import { formByEntityFieldId, TicketEntityIDFieldEnum } from '@/constants';
import { useFetchTicketFormFields } from '@/hooksApi';
import { useTicketingStore } from '@/stores';
import useLanguageStore from '@/stores/useLanguageStore';
import usePermission from './usePermission';
import { PermissionName } from '@/types';

export const useOpenEntityTicketModal = (entity: TicketEntityIDFieldEnum) => {
  const { openModal, setTicketFormData } = useTicketingStore();
  const { language } = useLanguageStore();

  const { hasPermission } = usePermission();

  const { data: formFieldList } = useFetchTicketFormFields(
    language,
    hasPermission(PermissionName.CREATE_TICKET),
  );

  const formId = formByEntityFieldId[entity].formId;

  const platformCodeField = formFieldList?.object
    .find((form) => form.id === formId)
    ?.fields.find((field) => field.id === entity);

  const openEntityTicketModal = (platformCode?: string, entityUid?: string) => {
    if (platformCodeField?.id) {
      setTicketFormData({
        ticket_form_id: formId,
        external_id: platformCode,
        entity_uid: entityUid,
        custom_fields: [
          {
            id: platformCodeField?.id,
            value: platformCode ?? '',
          },
        ],
      });
    }
    openModal();
  };

  return {
    openEntityTicketModal,
  };
};
